import { IconoGrupo, IconoInfo, IconoObjetivo } from "./iconos";

const OPCIONES = [
    { valor: "grupo", icono: <IconoGrupo />, titulo: "Simple", nota: "Como hasta hoy", detalle: "Compañía, sucursal y sede. El alcance lo define el grupo del usuario." },
    { valor: "organizacion", icono: <IconoObjetivo />, titulo: "Por organización", nota: "Exacto", detalle: "Sedes de una o varias compañías. El usuario verá exactamente las marcadas." },
]

export const Aviso = ({ texto, tono }: { texto: string; tono: "info" | "alerta" }) => (
    <div role="status" className={`tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-px-3 tw-py-2 tw-text-xs ${tono === "info" ? "tw-bg-indigo-50 tw-text-indigo-800" : "tw-bg-amber-50 tw-text-amber-800"}`}>
        <IconoInfo /><span>{texto}</span>
    </div>
)

// Parte superior del modal: tipo de configuración y avisos del tipo elegido.
export const SelectorConfiguracion = ({ acc }: { acc: any }) => (
    <div className="tw-flex tw-flex-col tw-gap-3">
        <div role="radiogroup" aria-label="Tipo de configuración" className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3">
            {OPCIONES.map((o) => {
                const activo = acc.modoBorrador === o.valor
                return (
                    <label key={o.valor} className={`tw-flex tw-items-start tw-gap-3 tw-rounded-xl tw-border-2 tw-p-3 tw-cursor-pointer tw-transition-colors ${activo ? "tw-border-primario tw-bg-indigo-50" : "tw-border-gray-200 hover:tw-border-gray-300 tw-bg-white"}`}>
                        <input type="radio" name="tipo-configuracion" className="tw-sr-only" checked={activo} onChange={() => acc.cambiarModo(o.valor)} />
                        <span className={`tw-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-lg ${activo ? "tw-bg-primario tw-text-white" : "tw-bg-gray-100 tw-text-gray-500"}`}>{o.icono}</span>
                        <span className="tw-flex-1">
                            <span className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold">{o.titulo}
                                <span className="tw-rounded-full tw-bg-white tw-border tw-px-2 tw-text-[10px] tw-font-medium tw-text-gray-500">{o.nota}</span></span>
                            <span className="tw-block tw-text-xs tw-text-gray-500 tw-mt-0.5">{o.detalle}</span>
                        </span>
                        <span className={`tw-mt-1 tw-h-4 tw-w-4 tw-shrink-0 tw-rounded-full tw-border-2 ${activo ? "tw-border-primario tw-bg-primario tw-shadow-[inset_0_0_0_3px_white]" : "tw-border-gray-300"}`} />
                    </label>
                )
            })}
        </div>
        {acc.modoBorrador === "organizacion" && acc.desdeVigentes &&
            <Aviso tono="info" texto="Están marcadas las sedes que el usuario ve hoy. Lo que cambie se aplica al guardar." />}
        {acc.modoBorrador === "grupo" && acc.sedesDescartadas > 0 &&
            <Aviso tono="alerta" texto={`${acc.sedesDescartadas} sede(s) de otras compañías no se conservan en la configuración simple.`} />}
    </div>
)
